define(function (require) {
	const view_manager = require('civicsUtils/view_manager');
	const ccn = require('../core_constants');

	const setup_view = require('./setup_view/v_lov_setup');
	const authentication_view = require('./authentication_view/v_lov_authentication');
	const confirmationModal = require('civicsViews/confirmation_modal/v_lov_confirmation_modal');
	const modal_region = require('civicsUtils/modal_region');

	const available_factors_collection = require('civicsCollections/available_factors_collection');

	const mfa_subscription_model = require('civicsModels/mfa_subscription_model');

	const responseUtils = require('./2fa_response_utils');
	const Utils = require('civicsUtils/general_utilities');
	const AvailableFeatures = require('civicsUtils/available_features');

	const _twoFactor = function (options) {
		options = options || {};
    
		let _modalRegion;
		if (options.modalRegion == null) {
			// Create default modal region
			_modalRegion = new modal_region({
				el: 'body .rhythm-modals'
			});
		} else {
			_modalRegion = options.modalRegion;
		}
	
		let _getAuthenticationStrings = function() {
			let globalConfig = view_manager.globalConfig().toJSON();
			let isFallbackMFAOn = !globalConfig.featureToggles.inactiveFeatures?.includes('Hansen.Portal.FeatureToggle.PortalMFAFallbackMethod');

			let mfaStrings = {
				methodTypeTitle: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.MFA_TITLE'),
				methodTypeAbbrev: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.MFA_ABBREV'),
				methodTypeText: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.MFA_TEXT'),
				methodTypeBody: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.MFA_BODY')
			};

			let twoFAStrings = {
				methodTypeTitle: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.2FA_TITLE'),
				methodTypeAbbrev: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.2FA_ABBREV'),
				methodTypeText: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.2FA_TEXT'),
				methodTypeBody: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.2FA_BODY')
			};

			if (AvailableFeatures.MFAEnforcedAndFallback() && isFallbackMFAOn) {
				return mfaStrings;
			} else {
				return twoFAStrings;
			}
		}

		let _showModalView = function (view) {
			if (_modalRegion.inst && _modalRegion.inst.state != 'closed') {
				//if we have a modal region inst state, it means we've previously used the modal. 
				//we need to make sure to clear out the modal and wait for it to close bfore opening the new view (via callback)
				_modalRegion.closeModalPromise = $.Deferred();
				_modalRegion.closeModalPromise.done(() => {
					_modalRegion.show(view);
					_modalRegion.showModal();
				});
				_modalRegion.hideModal();
			} else {
				_modalRegion.show(view);
				_modalRegion.showModal();
			}
		}

		//code type is either verification or authentication.
		let _showAuthenticationFailureModal = function (reason, promise, codeType) {
			//reasons we might need to show a failure modal:
			// AttemptExceeded
			// NoSecurityCode
			let failType = codeType.toUpperCase();
			if ([ccn.ATTEMPTEXCEEDED, ccn.NOSECURITYCODE].includes(reason.reason)) {
				let localizationParam = reason.reason.toUpperCase();
				_showConfirmationModal({
					title: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.FAILURE_'+failType+'_MODAL_TITLE'),
					instructions: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.FAILURE_' + failType+'_'+ localizationParam + '_MODAL_TEXT'),
					hideSubmitButton: true,
					cancelButtonText: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.FAILURE_'+failType+'_MODAL_CANCEL_BUTTON'),
					cancellationCallback: () => {
						if (promise) {
							promise.reject();
						} else {
							if (_modalRegion.inst) { // if promise is null
								_modalRegion.inst.close();
							}
						}
					},
					closeAfterSubmit: true
				});
			} else {
				//we should never get here.
				console.log('Unkown error occured: ' + reason.reason);
				promise.reject();
			}
		}

		let _showConfirmationModal = function (options) {
			let confirmationView = new confirmationModal(options);
			_showModalView(confirmationView);
		}

		let _showMFASetupSkipConfirmation = function (onConfirmCallback) {
			let methodType = _getAuthenticationStrings();
			return new confirmationModal({
				title: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.SKIP_SETUP_TITLE', {methodTypeAbbrev: methodType.methodTypeAbbrev}),
				instructions: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.SKIP_SETUP_MESSAGE'),
				submitButtonText: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.SKIP_SETUP_CONFIRM_BTN'),
				cancelButtonText: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.SKIP_SETUP_CANCEL_BTN'),
				hideCancelButton: true,
				confirmationCallback: onConfirmCallback
			});
		}

		let _promptForAuthenticationCode = (settings) => {
			let retPromise = new $.Deferred();
			let promptForAuthenticationCodePromise = new $.Deferred();
			settings.promptForAuthenticationCodePromise = promptForAuthenticationCodePromise;
			settings.methodType = _getAuthenticationStrings(); // Pass authentication strings
			let authenticationView = new authentication_view(settings);
			_showModalView(authenticationView);
			$.when(promptForAuthenticationCodePromise).done((response) => {
				retPromise.resolve(response);
			}).fail((reason) => {
				if (reason.tryAnotherMethod && reason.fallbackResponse) {
				// Parse the fallback response to extract factor details from JWT token
				let parsedFallbackResponse = responseUtils.parseResponse({ responseJSON: { data: reason.fallbackResponse } });
					// Handle fallback method - create new authentication view with fallback response
					let newSettings = {
						factor: parsedFallbackResponse.factor,
						mfaToken: reason.fallbackResponse.mfaToken,
						originalModel: settings.originalModel,
						codeType: settings.codeType,
						method: settings.method,
						isFallbackMethod: true, // Flag to be used to hide the "Try Another Method" button when the fallback method has been triggered.
						methodType: _getAuthenticationStrings() // Pass authentication strings
					};
					// Create new authentication view directly
					let newPromise = new $.Deferred();
					newSettings.promptForAuthenticationCodePromise = newPromise;
					let newAuthView = new authentication_view(newSettings);
					_showModalView(newAuthView);
					$.when(newPromise).done((response) => {
						retPromise.resolve(response);
					}).fail((fallbackReason) => {
						if (fallbackReason.reason != null) {
							_showAuthenticationFailureModal(fallbackReason, retPromise, settings.codeType);
						}
					});
				} else if (reason.reason != null) {//null indicates the user clicked out of the authentication window.
					_showAuthenticationFailureModal(reason, retPromise, settings.codeType);
				}
			})
			return retPromise;
		}

		let _setupAuthentication = (settings) => {
			let processCompletedProcessPromise = new $.Deferred();
			let setupAuthenticationPromise = new $.Deferred();
			let setupView = new setup_view({
				settings: settings,
				setupAuthenticationPromise: setupAuthenticationPromise
			});
			_showModalView(setupView);
			//authData is contains the initial auth response from the RS, and the model used to get the response. 
			//we will use the data in the response error message to update the model with the token and try again
			$.when(setupAuthenticationPromise).done((authData) => {

				let parsedResponse = responseUtils.parseResponse(authData.response);
				parsedResponse.originalModel = authData.originalModel;
				parsedResponse.codeType = ccn.VERIFICATION;
				parsedResponse.method = ccn.SAVE
				$.when(_promptForAuthenticationCode(parsedResponse)).done((response) => {
					$.when(_showSuccessModal(true, null, settings.dashboardUrl)).done(()=>{
						processCompletedProcessPromise.resolve({
							data:authData.originalModel.toJSON()
						});
					});
				}).fail((response) => {
					processCompletedProcessPromise.reject(response);
				});
			}).fail((response) => {
				processCompletedProcessPromise.reject(response);
			});
			return processCompletedProcessPromise;
		}

		let _showSuccessModal = (isSetup, promise, dashboardUrl)=>{
			let methodType = _getAuthenticationStrings();
			//subscribe vs unsubscribe :)
			let un = isSetup ? '' : 'UN';
			let retProm = $.Deferred();
			_showConfirmationModal({
				title: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.SUCCESS_MODAL_TITLE', {methodTypeTitle: methodType.methodTypeTitle}),
				instructions: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.SUCCESS_'+un+'SUBSCRIBE_MODAL_TEXT', {methodTypeText: methodType.methodTypeText}),
				hideSubmitButton: true,
				cancelButtonText: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.SUCCESS_MODAL_CANCEL_BUTTON'),
				cancellationCallback: () => {
					if(dashboardUrl && App.sessionStorage.get('CIVICS', 'MFA_SETUP_ACTIVE')) {
						App.sessionStorage.remove('CIVICS', 'MFA_SETUP_ACTIVE');
						App.sessionStorage.remove('CIVICS', 'MFA_RELOAD_LOGOUT');
						window.location.href = dashboardUrl;
					} else {
						if(promise){
							promise.resolve();
						}
						retProm.resolve();
					}
				}
			});
			return retProm;
		}

		let _disableAuthentication = (id) => {
			let disableAuthenticationPromise = $.Deferred();
			let methodType = _getAuthenticationStrings();
			_showConfirmationModal({
				title: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.DISABLE_MODAL_TITLE', {methodTypeTitle: methodType.methodTypeTitle} ),
				instructions: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.DISABLE_MODAL_TEXT', {methodTypeBody: methodType.methodTypeBody} ),
				submitButtonText: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.DISABLE_MODAL_SUBMIT_BUTTON'),
				cancelButtonText: i18n.t('CIVICS.LOGIN.FACTOR_AUTH.DISABLE_MODAL_CANCEL_BUTTON'),
				closeCallback: (confirmed)=>{
					if(confirmed){
						view_manager.loading(true);
						_removeMFASubscription(id, disableAuthenticationPromise)
					} else {
						disableAuthenticationPromise.reject();
					}
				},
				closeAfterSubmit: true,
				modalRegion:_modalRegion//because we're doing a closeCallback, we need to know about the modal region.
			});

			return disableAuthenticationPromise;
		}

		let _removeMFASubscription = (id, disableAuthenticationPromise) => {
			let mfaSub = new mfa_subscription_model({ id: id });
			mfaSub.subscriptionId = id;
			$.when(mfaSub.destroy()).done((response) => {
				//we should never be here
				console.log('Error removing MFA Subscription');
			}).fail((response) => {
				if (response.status == 403 &&
					response.responseJSON && 
					response.responseJSON.data &&
					response.responseJSON.data.mfaStatus.toLowerCase() == ccn.NOTIFIED) {
					let parsedResponse = responseUtils.parseResponse(response);
					parsedResponse.originalModel = mfaSub;
					parsedResponse.codeType = ccn.VERIFICATION;
					parsedResponse.method = ccn.DESTROY;
					$.when(_promptForAuthenticationCode(parsedResponse)).done(() => {
						_showSuccessModal(false, disableAuthenticationPromise, settings.dashboardUrl);
					}).fail((response) => {
						disableAuthenticationPromise.reject(response);
					});
				} else {
					view_manager.errorToWindow(response);
				}
			}).always(()=>{
				view_manager.loading(false);
			})
		}

		let _updateDefaultMFA = (id, setMFADefault, authFactorsCollection, showToast = true) => {
			view_manager.loading(true);

			let mfaSub = new mfa_subscription_model({ id: id });
			
			let methodType = _getAuthenticationStrings();
			mfaSub.subscriptionId = id;
			mfaSub.setPriority = setMFADefault;

			mfaSub.set({ isPrimary: setMFADefault });

			mfaSub.save(null, {
				success: (model, response) => {
					// Update the models to reflect the new primary status if collection provided
					if (authFactorsCollection) {
						authFactorsCollection.each((model) => {
							let newPriority = model.id == id ? 1 : 2;
							model.set('priority', newPriority);
						});
					}
					view_manager.loading(false);
					if (showToast) {
						Utils.civicsToastPop(i18n.t("CIVICS.LOGIN_FALLBACK.SET_DEFAULT_MFA_SUCCESS_TOAST_MSG", {methodTypeAbbrev: methodType.methodTypeAbbrev}), "success");
					}
				},
				error: (model, response) => {
					view_manager.errorToWindow(response);
					view_manager.loading(false);
				}
			});
		}
		
		let _authenticate = (response, originalModel) => {
			let parsedResponse = responseUtils.parseResponse(response);
			parsedResponse.originalModel = originalModel;
			parsedResponse.codeType = ccn.AUTHENTICATION
			parsedResponse.method = ccn.SAVE;
			return _promptForAuthenticationCode(parsedResponse);
		}

		_loadAvailableFactors = (isCalledFromLogin) => {
			let loadFactorsPromise = new $.Deferred();
			let availableFactors = new available_factors_collection();
			availableFactors.fetch({
				success: (collection, response) => {
					loadFactorsPromise.resolve(response);
				},
				error: (collection, response) => {
					if (!isCalledFromLogin) {
						view_manager.errorToWindow(response);
					}
					loadFactorsPromise.reject(response);
				}
			});
			return loadFactorsPromise;
		}

		let _disableAuthenticationEnforced = (id, methodType, isDefault, hasMultipleMethods) => {
			let disableAuthenticationPromise = $.Deferred();
			let instructions;
			let authType = _getAuthenticationStrings();
			
			if (hasMultipleMethods && isDefault) {
				instructions = i18n.t('CIVICS.LOGIN_FALLBACK.REMOVE_MFA_DEFAULT_MSG', { methodType: methodType || 'SMS', methodTypeBody: authType.methodTypeBody });
			}  else {
				instructions = i18n.t('CIVICS.LOGIN_FALLBACK.REMOVE_MFA_SINGLE_MSG', { methodType: methodType || 'SMS', methodTypeBody: authType.methodTypeBody});
			}
			
			_showConfirmationModal({
				title: i18n.t('CIVICS.LOGIN_FALLBACK.REMOVE_MFA_TITLE', {methodTypeAbbrev: authType.methodTypeAbbrev}),
				instructions: instructions,
				submitButtonText: i18n.t('CIVICS.LOGIN_FALLBACK.REMOVE_MFA_CONTINUE_BTN'),
				hideCancelButton: true,
				closeCallback: (confirmed)=>{
					if(confirmed){
						view_manager.loading(true);
						_removeMFASubscription(id, disableAuthenticationPromise)
					} else {
						disableAuthenticationPromise.reject();
					}
				},
				closeAfterSubmit: true,
				modalRegion:_modalRegion
			});

			return disableAuthenticationPromise;
		}

		let _showMFASetupInterruptedModal = () => {
			let methodType = _getAuthenticationStrings();
			_showConfirmationModal({
				title: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.SETUP_INTERRUPT_MODAL_HEADER', {methodTypeTitle: methodType.methodTypeTitle }),
				instructions: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.SETUP_INTERRUPT_MODAL_INSTRUCT', {methodTypeAbbrev: methodType.methodTypeAbbrev}),
				hideSubmitButton: true,
				cancelButtonText: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.SETUP_INTERRUPT_MODAL_CONFIRM_CANCEL'),
				cancellationCallback: () => {
					App.localStorage.remove('CIVICS', 'REQUIRES_MFA_ENROLLMENT');
					App.localStorage.remove('CIVICS', 'MFA_SETUP_TAB_ID');
					App.localStorage.set('CIVICS', 'MFA_MODAL_CLOSED', Date.now());
					window.location.href = '/c/portal/logout';
				}
			});
		}

		// Setup MFA storage listener for cross-tab communication
		let _setupMFAStorageListener = function() {
			// Listen for MFA modal being closed in other tabs
			window.addEventListener('storage', (e) => {
				if (e.key === 'CIVICS' && e.newValue && e.newValue.includes('MFA_MODAL_CLOSED')) {
					App.localStorage.remove('CIVICS', 'REQUIRES_MFA_ENROLLMENT');
					App.localStorage.remove('CIVICS', 'MFA_MODAL_CLOSED');
					window.location.href = '/c/portal/logout';
				}
			});
		};

		let _checkRequireMFAEnrollment = function () {
            // Check if user requires MFA enrollment and show modal if true (only once per session)
            let requiresMFAEnrollment = App.localStorage.get('CIVICS', 'REQUIRES_MFA_ENROLLMENT');
            if (requiresMFAEnrollment) {
                // Check if this is a page reload
                if (performance.getEntriesByType && performance.getEntriesByType('navigation').length > 0) {
                    let navEntry = performance.getEntriesByType('navigation')[0];
                    if (navEntry.type === 'reload') {
                        // Only logout if this is the original MFA setup tab
                        let originalMFATabId = App.localStorage.get('CIVICS', 'MFA_SETUP_TAB_ID');
                        let currentTabId = App.sessionStorage.get('CIVICS', 'TAB_ID');
                        if (originalMFATabId === currentTabId) {
                            App.localStorage.remove('CIVICS', 'REQUIRES_MFA_ENROLLMENT');
                            App.localStorage.remove('CIVICS', 'MFA_SETUP_TAB_ID');
                            window.location.href = '/c/portal/logout';
                            return;
                        } else {
                            // Different tab, always show MFA setup interrupted modal even if it's reloaded 
                        _showMFASetupInterruptedModal();
                            return;
                        }
                    }
                }
                _showMFASetupInterruptedModal();
                return;
            }
        };

		return {
			authenticate: _authenticate,
			disableAuthentication: _disableAuthentication,
			disableAuthenticationEnforced: _disableAuthenticationEnforced,
			setupAuthentication: _setupAuthentication,
			loadAvailableFactors: _loadAvailableFactors,
			showMFASetupSkipConfirmation: _showMFASetupSkipConfirmation,
			showAuthenticationFailureModal: _showAuthenticationFailureModal,
			showModalView: _showModalView,
			updateDefaultMFA: _updateDefaultMFA,
			showMFASetupInterruptedModal: _showMFASetupInterruptedModal,
			setupMFAStorageListener: _setupMFAStorageListener,
			checkRequireMFAEnrollment: _checkRequireMFAEnrollment,
			getAuthenticationStrings: _getAuthenticationStrings
		}
	}
	return _twoFactor;
});